import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

import Wrapper from "../UiStyle/Slider/Wrapper";
import Title from "../UiStyle/Title/Title";
import Subtitle from "../UiStyle/Subtitle/Subtitle";

// Зурагнууд
import hallstatt from "../../images/heroslider/hero_slider_1.jpeg";
import hvitserkur from "../../images/heroslider/hero_slider_2.jpeg";
import jacksonville from "../../images/heroslider/hero_slider_3.jpg";
import moraineLake from "../../images/heroslider/hero_slider_4.jpg";

const slides = [
  { img: jacksonville, titleColor: "#fff" },
  { img: hvitserkur, titleColor: "#fff" },
  { img: moraineLake, titleColor: "#fff" },
  { img: hallstatt, titleColor: "#fff" },
];

const HeroSection = () => {
  return (
    <Swiper
      modules={[Autoplay, EffectFade]}
      spaceBetween={0}
      slidesPerView={1}
      loop={true}
      effect="fade"
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      speed={1200}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <div
            style={{
              backgroundImage: `url(${slide.img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Wrapper>
              <Title style={{ color: slide.titleColor }}>OPTIMIZE INC</Title>
              <Subtitle>Build More Together...</Subtitle>
            </Wrapper>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeroSection;
